import { Box, Typography } from '@mui/material';
import { ArrowForwardIosRounded } from '@mui/icons-material';
import React, { ReactElement, ReactNode } from 'react';
import { Divider } from '..';

export interface InfoRowProps {
  name: string;
  value?: string | number | ReactNode;
  onOpen?: () => void;
  noDivider?: boolean;
  multiline?: boolean;
}

export const InfoRow = ({
  name,
  value,
  onOpen,
  noDivider = false,
  multiline = false,
}: InfoRowProps): ReactElement => {
  return (
    <>
      <Box mb={8} display="flex" justifyContent="space-between" flexWrap="wrap">
        <Box flex={{ xs: '1 0 100%', md: '0 1 ' }} whiteSpace="nowrap">
          <Typography sx={{ fontWeight: 600, fontSize: '0.875em' }}>
            {name}
          </Typography>
          {multiline && (
            <Typography
              whiteSpace="normal"
              onClick={onOpen}
              style={{
                cursor: onOpen ? 'pointer' : 'default',
                WebkitTapHighlightColor: 'rgba(0,0,0,0)',
              }}
            >
              {value}
            </Typography>
          )}
        </Box>
        <Box
          flex={1}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          lineHeight={1.2}
          minHeight={27}
          style={{
            cursor: onOpen ? 'pointer' : 'default',
            WebkitTapHighlightColor: 'rgba(0,0,0,0)',
          }}
          onClick={onOpen}
        >
          {!multiline && value}
          <Box ml={{ xs: 'auto', md: 30 }}>
            {!!onOpen && <ArrowForwardIosRounded color="primary" />}
          </Box>
        </Box>
      </Box>

      {!noDivider && (
        <Box mb={30}>
          <Divider size={2} />
        </Box>
      )}
    </>
  );
};
